export default function PrivacyPolicyPage() {
  const lastUpdated = "August 31, 2025";
  const contactEmail = "info@givetechtotheblind.com";

  return (
    <div className="bg-white dark:bg-gray-900">
      <header className="bg-gray-50 dark:bg-gray-800 py-12">
        <div className="container mx-auto px-4 text-center">
          <h1 className="text-4xl md:text-5xl font-extrabold text-gray-900 dark:text-white">Privacy Policy</h1>
          <p className="mt-4 text-lg text-gray-500 dark:text-gray-400">Last updated: {lastUpdated}</p>
        </div>
      </header>
      
      <main className="container mx-auto px-4 py-16 max-w-4xl">
        <div className="prose dark:prose-invert max-w-none text-gray-700 dark:text-gray-300 leading-relaxed">
          <p>
            GiveTech totheBlind ("we," "our," or "us") is committed to protecting your privacy. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you visit our website.
          </p>

          <h2>1. Information We Collect</h2>
          <p>We may collect information about you in a variety of ways. The information we may collect on the Service includes:</p>
          <h3>Personal Data</h3>
          <p>
            Personally identifiable information, such as your name, email address, and telephone number, that you voluntarily give to us when you register with the Service or when you choose to participate in various activities related to the Service, such as making a donation or starting a campaign.
          </p>
          <h3>Verification Data (Recipients Only)</h3>
          <p>
            If you register as a Recipient, we will collect sensitive information required for verification, including but not limited to: your age, gender, state of origin, personal bio, employment status, a profile photograph, and a government-issued identification document (e.g., NIN Slip, Voter's Card). This data is stored securely and used solely for the purpose of identity verification.
          </p>
          <h3>Financial Data</h3>
          <p>
            All financial information is stored and processed by our payment processor, Paystack. We do not collect or store any payment card details on our servers. We may collect information related to a donation transaction, such as the amount and date, for our records.
          </p>

          <h2>2. Use of Your Information</h2>
          <p>Having accurate information about you permits us to provide you with a smooth, efficient, and customized experience. Specifically, we may use information collected about you via the Service to:</p>
          <ul>
            <li>Create and manage your account.</li>
            <li>Process your donations and facilitate campaigns.</li>
            <li>Verify the identity of Recipients.</li>
            <li>Send you notifications regarding your account or a campaign you are involved with.</li>
            <li>Publicly display anonymized or approved information for Success Stories.</li>
            <li>Monitor and analyze usage and trends to improve your experience with the Service.</li>
          </ul>

          <h2>3. Disclosure of Your Information</h2>
          <p>We do not sell, trade, or otherwise transfer your personally identifiable information to outside parties. Certain information for approved campaigns will be made public, including:</p>
          <ul>
            <li>A Recipient's first name and last initial.</li>
            <li>A Recipient's profile photo (with a privacy blur).</li>
            <li>A Recipient's bio and reason for needing an Item.</li>
            <li>A Recipient's appreciation video for Success Stories.</li>
          </ul>
          <p>We may disclose your information to third parties that perform services for us or on our behalf, such as payment processing (Paystack) and cloud storage (Amazon Web Services S3).</p>
          
          <h2>4. Security of Your Information</h2>
          <p>
            We use administrative, technical, and physical security measures to help protect your personal information. We store sensitive documents on secure cloud infrastructure provided by Amazon Web Services (AWS). While we have taken reasonable steps to secure the personal information you provide to us, please be aware that despite our efforts, no security measures are perfect or impenetrable.
          </p>

          <h2>5. Contact Us</h2>
          <p>
            If you have questions or comments about this Privacy Policy, please contact us at: <a href={`mailto:${contactEmail}`}>{contactEmail}</a>
          </p>
        </div>
      </main>
    </div>
  );
}